import React, { Component } from 'react';
import Navbar from '../../components/navbar';
import { Link } from 'react-router-dom';
import { RedirectTo } from '../../util/utilLibrary';
import api from '../../services/new-api';


import { Form, FormGroup, Button, Spinner } from 'react-bootstrap';
import { formataDinheiro } from '../../util/formatacao';
import CardDetalhes from '../../components/cardDetalhes';
import Rodape from '../../components/rodape';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";

import CryptoJS from 'crypto-js';

library.add(fas);


class AprovaMovimento extends Component {


    constructor(props) {
        super(props);


        this.state = {
            idMov: '',
            numMov: '',
            nomeFantasia: '',
            valorLiquido: '',
            codtmv: '',
            usuarioMestre: '',
            dependencia: '',
            idAprovacao: '',
            sequencial: '',
            codusuario: '',
            validando: '',
            btnAprovaDisabled: '',
            nomevendedor: '',
            erro: '',
            warning: '',
            notaFiscal: '',
            medicao: '',
            semRelatorio: false,
        }
    }


    componentDidMount() {
        this.setState({
            idMov: this.props.match.params.idmov,
            numMov: this.props.match.params.numeromov,
            nomeFantasia: this.props.match.params.nomefantasia,
            valorLiquido: parseFloat(this.props.match.params.valor),
            codtmv: this.props.match.params.codtmv,
            usuarioMestre: this.props.match.params.usuariomestre,
            dependencia: this.props.match.params.dependencia,
            idAprovacao: this.props.match.params.idaprovacao,
            sequencial: this.props.match.params.sequencial,
            codusuario: this.props.match.params.codusuario,
            nomevendedor: this.props.match.params.nomevendedor,
            validando: false,
            btnAprovaDisabled: false,
            notaFiscal: this.props.match.params.notafiscal,
            medicao: '',
            semRelatorio: false,
        });
    }

    descriptografarApi() {
        const chave = 'CfYhNXxAIuBHWrA52mdFxfq3NUypaH1M10P3pgo/X/g=';

        const usuario = CryptoJS.AES.decrypt(window.api_user, chave).toString(CryptoJS.enc.Utf8);
        const senha = CryptoJS.AES.decrypt(window.api_pass, chave).toString(CryptoJS.enc.Utf8);

        const base64Credentials = btoa(`${usuario}:${senha}`);

        return base64Credentials;

    }

    verificaSeMovimentoFoiAprovado = async () => {
        try {
            const response = await fetch(window.url_RM + `CODCOLIGADA=${sessionStorage.getItem('RC_CODCOLIGADA')};IDMOV=${this.state.idMov}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Basic ${this.descriptografarApi()}`,
                    'Content-Type': 'application/json',
                },
            });

            const responseJson = await response.json();
            return responseJson;

        } catch (err) {
            console.log(err);
        }
    }

    getRelatorio = async () => {

        let config = {
            headers: {
                'IDMOV': this.state.idMov,
            }
        }

        try {
            const response = await api.get('/RelatorioMedicaoObras', config);
            this.setState({ relatorio: response.data.arquivo });

            switch (response.data.status) {

                case "0":
                    console.log("case 0");
                    this.setState({ semRelatorio: true });
                    break;

                case "1":
                    this.setState({ relatorio: response.data.arquivo });
                    console.log("case 1");
                    break;

                default:
                    this.setState({ semRelatorio: true });
                    console.log("default");
            }

        }
        catch (err) {
            this.setState({ semRelatorio: true })
        }

    }

    enviarEmailDocuSign = async (body) => {
        console.log(1);
        try {
            console.log(2);
            const response = await fetch(window.csharp_api + "api/DocuSign/SendDocumentToSignature", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(body),
            });
            console.log(3);
            const responseJson = await response.json();
            console.log(4);
            return responseJson;

        } catch (err) {
            console.log(err);
        }
    };

    envioDocuSign = async () => {
        const aprovado = await this.verificaSeMovimentoFoiAprovado();
        
        try {
            if(Object.keys(aprovado).length === 0) {
                return;
            }

            if (aprovado[0]['APROVADO'] == 1) {

                //Pegar o documento
                await this.getRelatorio();
    
                if (this.state.semRelatorio) {
                    this.setState({ validando: false, error: "Erro ao gerar o documento da medição!" });
    
                } else {
                    //Formar o json
                    let body = {
                        "numMov": this.state.numMov,
                        "documentBase64": this.state.relatorio,
                        "signers":
                            aprovado.map(pessoa => {
                                return { "email": pessoa['EMAIL'], "signerName": pessoa['NOME'], "tipoAssinante": pessoa['TIPOASSINANTE'] }
                            }),
                        "anexo": {
                            "codColRequisicao": sessionStorage.getItem("RC_CODCOLIGADA"),
                            "idReq": this.state.idMov,
                        }
                    }
    
                    //Enviar para a API em c#
                    const responseDocuSign = await this.enviarEmailDocuSign(body);
    
                    if (responseDocuSign.status != 200) {
                        this.setState({ validando: false, erro: "Ao enviar o documento para a assinatura!" });
                    }
                }
            }
        } catch (e) {
            throw new Error('Um erro inesperado ocorreu ao realizar o envio do documento para a assinatura. O MOVIMENTO FOI APROVADO!')
        }
       
    }

    //Implementar aqui
    handleAprovaMov = async e => {
        e.preventDefault();

        this.setState({ validando: true, btnAprovaDisabled: true });

        const body = {
            codcoligada: sessionStorage.getItem("RC_CODCOLIGADA"),
            idmov: String(this.state.idMov),
            codtmv: this.state.codtmv,
            codusuarioaprovacao: sessionStorage.getItem("RC_USR"),
            usuariomestre: String(this.state.usuarioMestre),
            dependencia: String(this.state.dependencia),
            idaprovacao: String(this.state.idAprovacao),
            sequencial: String(this.state.sequencial),
            codusuarioorigem: this.state.codusuario,
            nomevendedor: this.state.nomevendedor
        };

        const config = {
            params: {
                ALIAS: window.novo_alias_RC,
            }
        };

        try {
            const response = await api.put(
                "/Obras/v2/AprovaMovimento",
                body,
                config
            )

            const ret = response.data;

            this.setState({ ret });

            if (ret.CODIGO === "1") {

                if (this.state.codtmv === "1.1.30") {
                    await this.envioDocuSign();

                    // As linhas abaixo perterciam a função de pular para o próximo movimento ao finalizar a aprovação do movimento
                    // Aqui, eu pego o array de movimentos salvo na sessão, removo o ID do movimento atual e pulo para o próximo.
                    // Resolvi deixar as linhas comentadas, pois sinto que isso ainda poderá ser útil (y)


                    // const { match } = this.props;
                    // const id = match.params.id;

                    // let movimentos = JSON.parse(sessionStorage.getItem("idsMovimentos"));
                    // const movAtual = this.props.match.params.idmov;

                    // const innerArrayIndex = movimentos.findIndex(innerArray => innerArray.includes(parseInt(movAtual)));

                    // if (innerArrayIndex !== -1) {
                    //     // Remove o array interno usando o método splice
                    //     movimentos.splice(innerArrayIndex, 1);
                    // }

                    // sessionStorage.setItem("idsMovimentos", JSON.stringify(movimentos));

                    // if (movimentos.length === 0) {

                    //Colocar a logica do if aqui
                }

                if (this.state.notaFiscal === 0) {
                    RedirectTo("/movimentos/", this.props.history);
                } else {
                    RedirectTo("/notaFiscal/", this.props.history);
                }

            } else if (ret.CODIGO === "2") {

                this.setState({
                    validando: false,
                    btnAprovaDisabled: true,
                    warning: ret.DESCRICAO
                });

            } else {

                this.setState({
                    validando: false,
                    btnAprovaDisabled: false,
                    erro: ret.DESCRICAO
                });

            }
        }
        catch (err) {
            if (err.response.status == 400) {
                await this.handleAprovaMov(e);
            }
            this.setState({ validando: false, btnAprovaDisabled: false, erro: err.toString() });
            console.log(err);

        }
    }



    render() {
        return (
            <div>
                <Navbar />

                <CardDetalhes titulo="Aprovação do Movimento" subtitulo="Confira todos os dados abaixo!" btnImprimeVisible='false'>

                    {this.state.erro && <div className="alert alert-danger" role="alert">Erro:
                        <FontAwesomeIcon className="mr-2" icon="times" />
                        {this.state.erro}
                    </div>}

                    {this.state.warning && <div className="alert alert-warning" role="alert">
                        <FontAwesomeIcon className="mr-2" icon="exclamation-triangle" />
                        {this.state.warning}
                    </div>}

                    <Form onSubmit={this.handleAprovaMov}>
                        <Form.Row>
                            <FormGroup className="col-md-2">
                                <Form.Label htmlFor="inputNumMov">Num. Movimento</Form.Label>
                                <Form.Control readOnly id="inputNumMov" value={this.state.numMov} />
                            </FormGroup>

                            <FormGroup className="col-md-6">
                                <Form.Label htmlFor="inputNomeFantasia">Nome Fantasia</Form.Label>
                                <Form.Control readOnly id="inputNomeFantasia" value={this.state.nomeFantasia} />
                            </FormGroup>

                            <FormGroup className="col">
                                <Form.Label htmlFor="inputVlrLiquido">Valor Líquido</Form.Label>
                                <Form.Control readOnly id="inputVlrLiquido" value={formataDinheiro(this.state.valorLiquido ?? 0)} />
                            </FormGroup>
                        </Form.Row>
                        <hr />
                        <div className="text-right">
                            {this.state.notaFiscal == 1 ?
                                <Link to='/notaFiscal' className="btn btn-light mr-2">
                                    Cancelar
                                </Link>

                                :

                                <Link to='/movimentos' className="btn btn-light mr-2">
                                    Cancelar
                                </Link>
                            }

                            <Button type="submit" variant="success" disabled={this.state.btnAprovaDisabled}>
                                {this.state.validando ?
                                    <>
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            className="mr-2"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                        Aprovando...
                                    </>

                                    :
                                    <>
                                        <FontAwesomeIcon icon="check" className="mr-2" />
                                        Aprovar Movimento
                                    </>
                                }
                            </Button>
                        </div>
                    </Form>
                </CardDetalhes>

                <Rodape />

            </div>
        );
    }
}

export default AprovaMovimento;